<template>
  <v-menu
    :close-on-content-click="true"
    v-model="dOpenMenu"
    transition="scale-transition"
    min-width="auto" >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dFormatDate"
        :label="label"
        :disabled="disabled"
        :append-icon="appendIcon"
        :placeholder="placeholder"
        clearable
        hide-details
        v-bind="attrs"
        v-on="on" />
    </template>
    <v-date-picker v-model="dDate" no-title @input="dOpenMenu = false" />
  </v-menu>
</template>

<script>
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'

export default {
  mixins: [mxCanalDenuncias],
  name: "datDatePicker",
  props: [
    "label",
    "value",
    "appendIcon",
    "placeholder",
    "disabled"
  ],
  model: {
    prop: "value",
    event: "change",
  },

  data: () => ({
    dDate: null,
    dFormatDate: null,
    dOpenMenu: false,
  }),

  watch: {
    value(valor) {
      this.dFormatDate =  this.fDateFormat2(valor)
    },
    dDate(valor) {
      this.dFormatDate =  this.fDateFormat2(valor)
      this.$emit("change", valor)
    }
  },
}
</script>